import { render } from "./productgroup.vue?vue&type=template&id=2a92662c"
import script from "./productgroup.vue?vue&type=script&lang=js"
export * from "./productgroup.vue?vue&type=script&lang=js"

import "./productgroup.vue?vue&type=style&index=0&id=2a92662c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__